import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Figure from '../../entities/casis/figure'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface FigureState extends ListState<Figure>{
    editModel: Figure;
    dealers: Array<any>;
    reportList: Array<any>;
    activeList: Array<Figure>;
    loadingDealers: boolean;
    requestId: number;
}
class FigureModule extends ListModule<FigureState,any,Figure>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Figure>(),
        loading: false,
        loadingDealers: false,
        editModel: new Figure(),
        activeList: new Array<Figure>(),
        reportList: new Array<any>(),
        dealers: new Array<any>(),
        requestId: 0,
        path: 'figures'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getAll(context: ActionContext<FigureState, any>, payload: any) {
            const requestId = ++context.state.requestId;
            context.state.loading = true;
            let reponse = await Ajax.get('/api/' + (context.state as any).path, { params: payload.data }).catch(e => {
                if (requestId === context.state.requestId)
                    context.state.loading = false;
                return Promise.reject(e);
            });
            if (requestId !== context.state.requestId) return;
            context.state.loading = false;
            context.state.totalCount = reponse.data.result.length;
            context.state.list = reponse.data.result.list;
            context.state.activeList = reponse.data.result.figures;
        },
        async create(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/' + (context.state as any).path, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false; 
            return response.data.result;
        },
        async updateBatch(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.put('/api/figure-batch', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async updateConcept(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.put('/api/figure-concept', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async export(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/figures/export', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return reponse.data.result.filename;
        },
        async enable(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/figures/enable', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async confirm(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/figures/confirm', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async getDealers(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loadingDealers = true;
            let reponse = await Ajax.get('/api/figure-dealers', { params: payload.data }).catch(e => {
                context.state.loadingDealers = false;
                return Promise.reject(e);
            });
            context.state.loadingDealers = false;
            context.state.dealers = reponse.data.result;
        },
        async getResumenComparativo(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/resumen-comparativo', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.reportList = reponse.data.result;
        },
        async processApiCasis(context: ActionContext<FigureState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/casis-api', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        clearData(state: FigureState) {
            state.list = [];
            state.activeList = [];
            state.totalCount = 0;
            state.loading = false;
            state.requestId++;
        },
        edit(state: FigureState, model: Figure) {
            state.editModel = model;
            
        }, 
        new(state: FigureState, model: Figure) {
            state.editModel = Object.assign({});
        },
    });
}
const figureModule=new FigureModule();
export default figureModule;
